module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"placeholder":"Schnellsuche: Belegnummer","no-result":"Kein Ergebnis","save":"Speichern","cancel":"Abbrechen"},"en":{"placeholder":"Fast search: Receipt number","no-result":"No result"}}')
  delete Component.options._Ctor
}
